import { setCookie } from '../helpers/cookies';
import { get as _get } from 'lodash';
import { getTranslationKey } from '../modules/utils';

type AnyRecord = { [key: string]: any };

interface MenuItem {
  name: any;
  url?: string;
  icon: string;
  attributes?: Record<string, any>;
  children?: MenuItem[];
}

interface MenuRoutes {
  items: MenuItem[];
}

// Type declarations moved to types/window.d.ts

function get(user: AnyRecord): MenuRoutes {
  try {
    const routes: MenuRoutes = {
      items: [
        {
          name: getTranslationKey('userDashboard.title'),
          url: '/dashboard',
          icon: 'icon-graph'
        },
        {
          name: getTranslationKey('myCollections'),
          url: '/collections',
          icon: 'icon-grid',
          attributes: {
            'data-cy': 'collections-dropdown'
          }
        },
        {
          name: getTranslationKey('portfolio.portfolios'),
          url: '/portfolios',
          icon: 'icon-folder-alt',
          attributes: {
            'data-cy': 'collections-dropdown'
          }
        },
        {
          name: getTranslationKey('settings'),
          url: '/settings',
          icon: 'icon-settings',
          attributes: {
            className: 'help_setupBrand_menu'
          }
        },
        {
          name: getTranslationKey('shop.shopMenuLabel'),
          url: '/shop',
          icon: 'icon-basket',
          attributes: {
            className: 'nav-link nav-dropdown-toggle'
          },
          children: [
            {
              name: getTranslationKey('shop.paymentSettings.pageTitle'),
              url: '/shop/payment-settings',
              icon: 'icon-wallet'
            },
            {
              name: getTranslationKey('shop.priceMenuLabel'),
              url: '/shop/prices',
              icon: 'icon-basket'
            },
            {
              name: getTranslationKey('shop.couponsMenuLabel'),
              url: '/shop/coupons',
              icon: 'icon-tag'
            },
            {
              name: getTranslationKey('shop.ordersMenuLabel'),
              url: '/shop/orders',
              icon: 'icon-list'
            },
            {
              name: getTranslationKey('shop.sales-automation.title'),
              url: '/shop/sales-automation',
              icon: 'icon-loop'
            }
          ]
        },
        {
          name: getTranslationKey('accountData'),
          url: '/account',
          icon: 'icon-user'
        }
      ]
    };

    if (
      (user.type === 'VST' && !_get(user, 'additionalFeatures', []).includes('shop')) ||
      _get(user, 'whiteLabel.hideElements', []).includes('shop')
    ) {
      routes.items.splice(4, 1);
    }

    if (user.type === 'SB') {
      const items = [
        {
          name: getTranslationKey('subscriptionLabel'),
          icon: 'icon-diamond',
          url: '/subscription'
        },
        {
          name: getTranslationKey('referralProgram.menu'),
          icon: 'icon-paper-plane',
          url: '/referral'
        }
        // {
        //   name: getTranslationKey('changelogMenuLabel'),
        //   icon: 'icon-bell',
        //   attributes: {
        //     'data-canny-changelog': '',
        //     className: 'never-active',
        //     onClick(e: any) {
        //       e.preventDefault();
        //     }
        //   }
        // }
      ];
      routes.items.push(...items);
    }

    routes.items.push({
      name: getTranslationKey('logout'),
      icon: 'icon-logout',
      attributes: {
        className: 'never-active',
        onClick() {
          if (typeof window.analytics.reset === 'function') {
            window.analytics.reset();
          }

          window.localStorage.removeItem('auth');
          window.localStorage.removeItem('subscriptionConfig');
          setCookie('rescrictionModalClosed', '', 0);

          if (_get(window, 'Intercom.booted')) {
            window.Intercom('shutdown');
          }

          window.location.href = window.API_URL + '/api/logout';
        }
      }
    });

    return routes;
  } catch (e) {
    console.log(e);

    return { items: [] };
  }
}

export default get;
